/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Checkbox, Dropdown } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
import { styles } from 'blb-inputs/common';
export const getUserRoleCheckboxConfig = (label, valueFieldName) => {
  return {
    component: WrappedInput,
    containerStyles: [styles.fieldWrapper],
    customComponentProps: {},
    inputComponent: Checkbox,
    label,
    labelPosition: 'right',
    labelSize: 'sm',
    name: valueFieldName,
    type: 'checkbox'
  };
};
export const groupInputConfig = function (options) {
  let disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let selectedValue = arguments.length > 2 ? arguments[2] : undefined;
  return {
    component: WrappedInput,
    containerStyles: [styles.fieldWrapper],
    customComponentProps: {
      options,
      ...(disabled && {
        disabled,
        value: selectedValue
      })
    },
    inputComponent: Dropdown,
    label: 'Group',
    labelSize: 'sm',
    name: 'groupId'
  };
};